module.exports = __webpack_public_path__ + "img/a.937e673e.png";